export default __webpack_public_path__ + "static/media/171126-5-qualidades-para-ser-um-cozinheiro-de-primeira-1317x879.1849c38f.jpg";